var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuanzhe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01_\u60A3\u8005") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.87,34.46a15.22,15.22,0,0,0,10.77-26A15.23,15.23,0,1,0,21.1,30,15.12,15.12,0,0,0,31.87,34.46Zm0-4.05a11.18,11.18,0,0,1-9.9-6l11.7-6.83,9.09,4.15A11.19,11.19,0,0,1,31.87,30.41Zm9.35-17.27a11,11,0,0,1,1.65,4.16L38,15.05Zm-2.89-3L33.44,13,26.15,9.66a11.07,11.07,0,0,1,12.18.47Zm-15.45,2.5,6.28,2.86-8.4,4.91a11.13,11.13,0,0,1,2.12-7.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.86,44.88a17.84,17.84,0,0,0-5.28-5.16A30.64,30.64,0,0,0,32,35.2a30.62,30.62,0,0,0-16.6,4.52,17.88,17.88,0,0,0-5.29,5.16,12.19,12.19,0,0,0-2,6.67,7.53,7.53,0,0,0,2.13,5.62c3.24,3.19,9.32,3.09,17,3,1.55,0,3.14-.05,4.78-.05s3.24,0,4.78.05,2.85,0,4.18,0c5.72,0,10.22-.42,12.84-3a7.57,7.57,0,0,0,2.13-5.62A12.12,12.12,0,0,0,53.86,44.88ZM51,54.29c-2,2-7.9,1.89-14.12,1.79-1.56,0-3.17,0-4.84,0s-3.29,0-4.86,0c-6.22.1-12.09.2-14.12-1.79a3.51,3.51,0,0,1-.92-2.73c0-3.12,2-6.11,5.5-8.43A26.62,26.62,0,0,1,32,39.26a26.62,26.62,0,0,1,14.39,3.87c3.54,2.32,5.5,5.31,5.5,8.43A3.51,3.51,0,0,1,51,54.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuanzhe);
export default __webpack_public_path__ + "static/media/huanzhe.e04beaff.svg";
export { ForwardRef as ReactComponent };